import { Component, OnInit, Output, EventEmitter, Input, HostBinding } from '@angular/core';
import { ErrCode } from '../../shared/models';
import { FormBuilder } from '@angular/forms';
import * as fromRoot from '../../reducers';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { LoggerService } from '../../core/logger.service';

@Component({
    selector: 'app-link-consume-password',
    templateUrl: './link-consume-password.component.html',
    styleUrls:['./link-consume-password.component.scss']
})
export class LinkConsumePasswordComponent implements OnInit {

    @Output() password = new EventEmitter<string>();
    @Input() errcode: ErrCode;

    public spinner = false;
    public passwordfield: string;
    public sub: Subscription;
    //white label attrs
    public buttonPrimaryColor: string;
    public buttonTextColor: string;
    public whiteLabelLoaded: boolean;
    constructor(
        private store: Store<fromRoot.State>,
        private sanitizer: DomSanitizer,
    ) { }

    ngOnInit() {
        this.sub = this.store.select(fromRoot.getLinkFileListState).subscribe((data) => {
            if (data.whitelabel_loaded) {
                this.buttonPrimaryColor = data.button_primary_color;
                this.buttonTextColor = data.button_text_color;
            }
        });
        this.spinner = false;
    }

    public setPassword = () => {
        this.spinner = true;
        this.password.emit(this.passwordfield);
        this.spinner = false;
    }
}
